import React from 'react';
import { Link, type LinkProps } from 'react-router-dom';

type CleaningToolLinkProps = Omit<LinkProps, 'target' | 'rel'> & {
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
  variant?: 'default' | 'forge';
};

export const CleaningToolLink: React.FC<CleaningToolLinkProps> = ({
  target = '_blank',
  rel = 'noopener noreferrer',
  variant = 'default',
  className,
  ...props
}) => {
  const classes = [variant === 'forge' ? 'forge-cleaning-tool-link' : null, className]
    .filter(Boolean)
    .join(' ');
  return <Link {...props} className={classes || undefined} target={target} rel={rel} />;
};
